import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// Components
import Select from 'ui/Form/Select'

// Const
import { BANK, DEPOSIT, GCASH, PAYMENT_METHODS } from 'models/Payment'

export const SelectPaymentMethod = ({ value, onChange, ...props }) => {
  const selected = useMemo(() => {
    const items = []
    const methods = value ? value.split(',') : []

    if (DEPOSIT.some((x) => methods.includes(x))) {
      items.push(DEPOSIT.join(','))
    }

    if (BANK.some((x) => methods.includes(x))) {
      items.push(BANK.join(','))
    }

    if (GCASH.some((x) => methods.includes(x))) {
      items.push(GCASH.join(','))
    }

    return items
  }, [value])

  return (
    <Select
      multiple={true}
      value={selected}
      placeholder="Payment method"
      options={PAYMENT_METHODS}
      onChange={(e) => onChange(e.join(','))}
      {...props}
    />
  )
}

SelectPaymentMethod.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
}

SelectPaymentMethod.defaultProps = {
  value: null,
  onChange: () => {},
}

export default SelectPaymentMethod
